import React from 'react';
const footer = ( props ) => (
    <footer className="footer"> </footer>
);

export default footer;